// extracted by mini-css-extract-plugin
module.exports = {"berbix__container":"berbix_berbix__container__YJOTz","berbix_buttons":"berbix_berbix_buttons__tdjOl"};